import React from 'react'
// import Header from'../Header/header'
function LayOut({ children }) {
  return (
    <div>
      {children}
    </div>
  )
}

export default LayOut
